import { createFileRoute } from "@tanstack/react-router";
import { marketingHead } from "../marketing-content/head";
import { MarketingSupportUseCasePage } from "../components/marketing/MarketingSupportUseCasePage";

export const Route = createFileRoute("/use-cases/support")({
  head: () => marketingHead("/use-cases/support"),
  component: MarketingSupportUseCasePage,
});
